import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { getStyles, translate } from '../../../shared/utility';
import * as actions from '../../../store/actions/index';

import Menu from '../Menu/Menu';

import Popup from '../../UI/Popup/Popup';
import Button from '../../UI/Button/Button';
import Icon from '../../UI/Icon/Icon';

import CartButton from '../../../containers/Cart/CartButton/CartButton';

import userPlaceholder from '../../../assets/images/img-contact-placeholder.svg';

import localStyles from './NavItems.scss';
const styles = getStyles(localStyles);

class NavItems extends Component {

    toggleMenu = () => {
        this.props.onSetGlobalState('isMenuOpen');
        this.props.onSetGlobalState(['isMobileSearchOpen', 'isSignupOpen', 'isLoginOpen'], false);
    };

    toggleMobileSearch = () => {
        this.props.onSetGlobalState('isMobileSearchOpen');
        this.props.onSetGlobalState(['isMenuOpen', 'isSignupOpen', 'isLoginOpen'], false);
    };

    openLogin = (type) => {
        this.props.onSetGlobalState('isLoginOpen', true);
        this.props.onSetGlobalState(['isMenuOpen', 'isMobileSearchOpen'], false);
    };

    openSignup = (type) => {
        this.props.onSetGlobalState('isSignupOpen', true);
        this.props.onSetGlobalState(['isMenuOpen', 'isMobileSearchOpen'], false);
    };

    render() {

        return (
            <nav>
                <ul className={styles('nav', 'no-list-style')}>
                    {/* Portrait Login and Signup buttons */}
                    {this.props.isAuthorized ? null : (
                        <Fragment>
                            <li className={styles('nav__item', 'portrait')}>
                                <Button modifiers={['text']} events={{ click: this.openSignup }}>
                                    {translate('menu.main.signup', this.props.language)}
                                </Button>
                            </li>
                            <li className={styles('nav__item', 'portrait')}>
                                <Button modifiers={['text']} events={{ click: this.openLogin }}>
                                    {translate('menu.main.login', this.props.language)}
                                </Button>
                            </li>
                        </Fragment>
                    )}
                    {/* Menu + button */}
                    {!this.props.isAuthorized ? null : (
                        <li className={styles('nav__item', 'nav__user')}>
                            <Button modifiers={['text']} events={{ click: this.toggleMenu }}>
                                <img className={styles('nav__user__picture', 'nav__user__picture--border', 'circle')}
                                    src={!!this.props.paymentAccountDetailsData && this.props.paymentAccountDetailsData.imageReference ? this.props.paymentAccountDetailsData.imageReference.source : userPlaceholder}
                                    alt='' />
                                <Icon icon={'arrow-down'} classes={styles('nav__user__icon', 'portrait')} modifiers={['small']} />
                            </Button>
                            {this.props.isMenuOpen ? (
                                <Popup isOpen={true} close={this.toggleMenu} fullscreenOnDevices={true}>
                                    <Menu
                                        menu={'user'}
                                        type={'dropdown'}
                                        iconSize={'default'}
                                        items={[
                                            { title: 'menu.user.preferences', icon: 'settings', submenu: 'preferences' },
                                            { title: 'menu.user.logout', click: this.props.onLogout, icon: 'signout' }
                                        ]}
                                    />
                                </Popup>
                            ) : null}
                        </li>
                    )}
                    {/* Mobile Login and Signup buttons */}
                    {this.props.isAuthorized ? null : (
                        <li className={styles('nav__item', 'nav__user', 'mobile-only')}>
                            <Button modifiers={['square']} events={{ click: this.toggleMenu }}>
                                <Icon icon={'user'} modifiers={['large']} classes={styles('nav__mobile-icon')} />
                            </Button>
                            {this.props.isMenuOpen ? (
                                <Popup isOpen={true} close={this.toggleMenu} fullscreenOnDevices={true}>
                                    <Menu
                                        menu={'custom'}
                                        type={'dropdown'}
                                        iconSize={'default'}
                                        items={[
                                            { title: 'menu.main.signup', click: this.openSignup },
                                            { title: 'menu.main.login', click: this.openLogin }
                                        ]}
                                    />
                                </Popup>
                            ) : null}
                        </li>
                    )}
                    {/* Mobile Search Button */}
                    <li className={styles('nav__item', 'nav__user', 'mobile-only')}>
                        <Button modifiers={['square']} events={{ click: this.toggleMobileSearch }}>
                            <Icon icon={'search'} modifiers={['large']} classes={styles('nav__mobile-icon')} />
                        </Button>
                    </li>
                    {/* Cart button */}
                    {!this.props.isAuthorized ? null : (
                        <li className={styles('nav__item')}>
                            <CartButton items={this.props.cartItems} pricing={this.props.cartPricing} />
                        </li>
                    )}
                </ul>
            </nav>
        );
    }
}

NavItems.propTypes = {
    // properties
    isAuthorized: PropTypes.bool.isRequired,
    paymentAccountDetailsData: PropTypes.object,
    isMenuOpen: PropTypes.bool,
    communityDetailsLoading: PropTypes.bool,

    cartItems: PropTypes.object,
    cartPricing: PropTypes.object,

    locale: PropTypes.string.isRequired,
    language: PropTypes.string.isRequired,

    // functions
    onLogout: PropTypes.func.isRequired,
    onSetGlobalState: PropTypes.func.isRequired
};

const mapStateToProps = state => {
    return {
        isAuthorized: !!state.details.user.data,
        paymentAccountDetailsData: state.details.paymentAccount.data,
        isMenuOpen: state.global.isMenuOpen,
        communityDetailsLoading: state.details.community.loading,

        cartItems: {
            data: state.details.cart.data,
            loading: state.details.cart.loading,
            error: state.details.cart.error
        },
        cartPricing: {
            data: state.details.cartPricing.data,
            loading: state.details.cartPricing.loading,
            error: state.details.cartPricing.error
        },

        locale: state.global.localization.locale,
        language: state.global.localization.language
    };
};

const mapDispatchToProps = dispatch => {
    return {
        onLogout: () => dispatch(actions.logout()),
        onSetGlobalState: (identifier, value) => dispatch(actions.setGlobalState(identifier, value))
    };
};


export default connect(mapStateToProps, mapDispatchToProps)(NavItems);



// WEBPACK FOOTER //
// ./src/components/Navigation/NavItems/NavItems.js